import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from './firebaseConfig';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  updateProfile,
  signInAnonymously,
  GithubAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  OAuthProvider,
  } from 'firebase/auth';
import { getRandomMessage, handleVSCodeRedirect } from './AuthUtils';
import './AuthPage.css';
import HomeButton from './HomeButton';
import Footer from './Footer';

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
    const googleProvider = new GoogleAuthProvider();
    const githubProvider = new GithubAuthProvider();
    const facebookProvider = new FacebookAuthProvider();
    const twitterProvider = new TwitterAuthProvider();
    const microsoftProvider = new OAuthProvider("microsoft.com");

  useEffect(() => { handleVSCodeRedirect(auth); }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      handleVSCodeRedirect(auth);
      navigate('/chat');
    } catch (err) { setError(getRandomMessage(err.code)); }
    finally { setLoading(false); }
  };

  const signInWithProvider = async (provider) => {
    try {
      await signInWithPopup(auth, provider);
      navigate('/chat');
    } catch (err) { setError(getRandomMessage(err.code)); }
  };
 const handleAnonymousSignIn = async () => {
    setError('');
    setLoading(true);
    try {
      await signInAnonymously(auth);
      const params = new URLSearchParams(window.location.search);
      if (params.get('source') === 'vscode' && auth.currentUser) {
        const token = await auth.currentUser.getIdToken();
        const uid = auth.currentUser.uid;
        const mail = auth.currentUser.email || '';
        window.location.href = `vscode://ozia.ozia-extension/auth?uid=${uid}&email=${encodeURIComponent(mail)}&token=${token}`;
      } else {
        // Navigate to chat page for web users
        navigate('/chat');
      }
    } catch (err) {
      setError(getRandomMessage(err.code));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
        <HomeButton />
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img src="/logo.png" alt="OZIA" className="ozia-ai-logo"/>
            <h1>ozia AI</h1>
            <p>Welcome back</p>
          </div>
          <form onSubmit={handleSignIn} className="auth-form">
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="submit-btn" disabled={loading}>Sign In to start</button>
                      <div className="divider">
            <span>OR</span>
          </div>
<div className="alternative-auth">
  <button
    className="google-btn"
    onClick={() => signInWithProvider(googleProvider)}
    disabled={loading}
    title="Continue with Google"
  >
    <i className="fab fa-google"></i>
  </button>

  <button
    className="github-btn"
    onClick={() => signInWithProvider(githubProvider)}
    disabled={loading}
    title="Continue with GitHub"
  >
    <i className="fab fa-github"></i>
  </button>

  <button
    className="facebook-btn"
    onClick={() => signInWithProvider(facebookProvider)}
    disabled={loading}
    title="Continue with Facebook"
  >
    <i className="fab fa-facebook-f"></i>
  </button>

  <button
    className="twitter-btn"
    onClick={() => signInWithProvider(twitterProvider)}
    disabled={loading}
    title="Continue with Twitter"
  >
    <i className="fab fa-twitter"></i>
  </button>

  <button
    className="microsoft-btn"
    onClick={() => signInWithProvider(microsoftProvider)}
    disabled={loading}
    title="Continue with Microsoft"
  >
    <i className="fab fa-microsoft"></i>
  </button>

  <button
    className="anonymous-btn"
    onClick={handleAnonymousSignIn}
    disabled={loading}
    title="Continue anonymously"
  >
    <i className="fas fa-user-secret"></i>
  </button>
</div>

          </form>
          <div className="auth-toggle">
            <p>Don't have an account? <Link to="/signup" className="toggle-link">Sign Up</Link></p>
          </div>
        </div>
      </div>
            {/* Footer */}
            <div className="footer-wrapper">
              <Footer />
            </div>
    </div>
  );
};

export default SignIn;